/* TEKA: reference-only local currency estimates. Checkout stays in the store currency. */
(() => {
  'use strict';
  const body = document.body;
  if (!body) return;
  const BASE = (body.dataset.tekaBaseCurrency || 'IDR').toUpperCase();
  const countryCurrency = {
    ID:'IDR', AU:'AUD', US:'USD', GB:'GBP', CA:'CAD', SG:'SGD',
    NZ:'NZD', MY:'MYR', JP:'JPY', KR:'KRW', IN:'INR', CH:'CHF',
    HK:'HKD', AE:'AED', SE:'SEK', DK:'DKK', NO:'NOK', MX:'MXN',
    BR:'BRL', ZA:'ZAR', TH:'THB', PH:'PHP', AT:'EUR', BE:'EUR',
    BG:'EUR', HR:'EUR', CY:'EUR', CZ:'CZK', DE:'EUR', EE:'EUR',
    ES:'EUR', FI:'EUR', FR:'EUR', GR:'EUR', HU:'HUF', IE:'EUR',
    IT:'EUR', LT:'EUR', LU:'EUR', LV:'EUR', MT:'EUR', NL:'EUR',
    PL:'PLN', PT:'EUR', RO:'RON', SI:'EUR', SK:'EUR'
  };
  const selectionKey='teka-explicit-delivery-country';
  let country=(body.dataset.tekaCountry || 'ID').toUpperCase();
  try {
    const saved=sessionStorage.getItem(selectionKey);
    if(saved && countryCurrency[saved]) country=saved;
  } catch(_) {}
  const countrySelect=document.getElementById('TekaCountry');
  if(countrySelect) countrySelect.addEventListener('change', () => {
    try { sessionStorage.setItem(selectionKey,countrySelect.value.toUpperCase()); } catch(_) {}
  });
  const rateEndpoint='https://api.frankfurter.dev/v2/rates?base='+BASE+'&quotes=';
  let rates={};
  function validRate(entry) {
    if (!entry || !Number.isFinite(Number(entry.rate)) || Number(entry.rate)<=0) return false;
    const when=Date.parse(entry.date);
    return Number.isFinite(when) && Math.abs(Date.now()-when)<35*86400000;
  }
  function display() {
    const currency=countryCurrency[country] || BASE;
    const rate=rates[currency];
    document.querySelectorAll('[data-teka-local-price]').forEach(node=>{
      const cents=Number(node.dataset.tekaIdrCents);
      if(currency===BASE || !Number.isFinite(cents) || cents<0 || !rate) {
        node.hidden=true;
        node.textContent='';
        return;
      }
      const converted=(cents/100)*rate.rate;
      if(!Number.isFinite(converted)) {node.hidden=true;return;}
      let formatted;
      try {
        formatted=new Intl.NumberFormat('en-'+country, {style:'currency', currency:currency, currencyDisplay:'code',maximumFractionDigits:2}).format(converted);
      } catch(_) {
        formatted=currency+' '+converted.toFixed(2);
      }
      node.textContent='≈ '+formatted+' · indicative rate '+rate.date+' · checkout in '+BASE;
      node.hidden=false;
    });
  }
  async function detect() {
    try {
      const explicitlySelected=sessionStorage.getItem(selectionKey);
      if(explicitlySelected && countryCurrency[explicitlySelected]) return;
    } catch(_) {}
    // Detect visitor country even when Shopify's default market is not Indonesia; do not redirect or overwrite an explicit selection.
    try {
      const root=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root)||'/';
      const url=root+'browsing_context_suggestions.json?country[enabled]=true';
      const response=await fetch(url,{credentials:'same-origin'});
      if(!response.ok)return;
      const data=await response.json();
      const detected=String((data.detected_values && data.detected_values.country && data.detected_values.country.handle)||'').toUpperCase();
      if(countryCurrency[detected])country=detected;
    } catch(_) {}
  }
  async function loadRates() {
    const all=[...new Set(Object.values(countryCurrency))].filter(value=>value!==BASE);
    try {
      const response=await fetch(rateEndpoint+encodeURIComponent(all.join(',')),{mode:'cors',cache:'no-store'});
      if(!response.ok) return;
      const data=await response.json();
      if(!Array.isArray(data)) return;
      rates=Object.fromEntries(data.filter(validRate).map(entry=>[String(entry.quote).toUpperCase(),{rate:Number(entry.rate),date:String(entry.date)}]));
    } catch(_) { rates={}; }
  }
  document.querySelectorAll('[data-teka-product-form]').forEach(form=>{
    form.addEventListener('change',event=>{
      const variant=event.target.closest('input[name="id"][data-price-cents]');
      const priceNode=document.querySelector('.teka-local-estimate--product');
      if(variant && priceNode) {
        priceNode.dataset.tekaIdrCents=variant.dataset.priceCents;
        display();
      }
    });
  });
    /* teka-owner-20261001: the delivery estimate for the detected country. Checkout stays the authority. */
  function showShipping() {
    const node=document.querySelector('[data-teka-ship]');
    const source=document.getElementById('TekaShipRates');
    if(!node || !source) return;
    let table={};
    try { table=JSON.parse(source.textContent||'null')||{}; } catch(_) { table={}; }
    const quote=(table.rates||{})[country];
    let name=country;
    try { name=new Intl.DisplayNames(['en'],{type:'region'}).of(country)||country; } catch(_) {}
    if(!quote) { node.textContent='Shipping to '+name+': calculated at checkout.'; node.hidden=false; return; }
    const base=(table.currency||BASE).toUpperCase();
    let amount;
    try { amount=new Intl.NumberFormat(base==='IDR'?'id-ID':'en-US',{style:'currency',currency:base,maximumFractionDigits:base==='IDR'?0:2}).format(quote.rate); }
    catch(_) { amount=base+' '+quote.rate; }
    const currency=countryCurrency[country]||BASE;
    const rate=rates[currency];
    let local='';
    if(rate && currency!==base) {
      try { local=' (≈ '+new Intl.NumberFormat('en-'+country,{style:'currency',currency:currency,currencyDisplay:'code',maximumFractionDigits:2}).format(quote.rate*rate.rate)+')'; } catch(_) {}
    }
    const days=quote.min&&quote.max?(quote.min===quote.max?quote.min:quote.min+'–'+quote.max)+' business days':'';
    node.textContent='Shipping to '+name+': '+amount+local+(days?' · '+days:'')+' · final rate at checkout';
    node.hidden=false;
  }
  Promise.all([detect(),loadRates()]).then(()=>{display();showShipping();},()=>{showShipping();});
})();
